/* tslint:disable */
/*
    TraCert API generated
    TraCert API
    version: v1
    Contact name: Helmes
    Contact email: info@helmes.com
    Url: https://www.helmes.com/
*/

export class Configuration {
    basePath?= '';
    fetchMethod = window.fetch;
    headers?: any = {};
    getHeaders: any = () => { return {} };

    constructor(config: Configuration | any) {
        if (config) {
            if (config.basePath) {
                this.basePath = config.basePath;
            }
            if (config.fetchMethod) {
                this.fetchMethod = config.fetchMethod;
            }
            if (config.headers) {
                this.headers = config.headers;
            }
            if (config.getHeaders) {
                this.getHeaders = config.getHeaders;
            }
        }
    }
}


export class CountryDto {
    id?: number;
    name: string;

    constructor(obj: CountryDto) {
        this.id = obj.id;
        this.name = obj.name;
    }
}

export class BillingSettingListItemDto {
    id?: string;
    country?: CountryDto;
    price?: number;

    constructor(obj: BillingSettingListItemDto) {
        this.id = obj.id;
        this.country = obj.country;
        this.price = obj.price;
    }
}

export class BillingSettingCreateDto {
    countryId?: number;
    price?: number;

    constructor(obj: BillingSettingCreateDto) {
        this.countryId = obj.countryId;
        this.price = obj.price;
    }
}

export class BillingMultiplierDto {
    id?: string;
    billingSettingId?: string;
    fromCertificates?: number;
    toCertificates: number;
    multiplierPercent?: number;
    created?: string;
    modified: string;

    constructor(obj: BillingMultiplierDto) {
        this.id = obj.id;
        this.billingSettingId = obj.billingSettingId;
        this.fromCertificates = obj.fromCertificates;
        this.toCertificates = obj.toCertificates;
        this.multiplierPercent = obj.multiplierPercent;
        this.created = obj.created;
        this.modified = obj.modified;
    }
}

export class BillingSettingDto {
    id?: string;
    country?: CountryDto;
    price?: number;
    created?: string;
    modified: string;
    billingMultipliers: BillingMultiplierDto[];

    constructor(obj: BillingSettingDto) {
        this.id = obj.id;
        this.country = obj.country;
        this.price = obj.price;
        this.created = obj.created;
        this.modified = obj.modified;
        this.billingMultipliers = obj.billingMultipliers;
    }
}

export class BillingMultiplierCreateEditDto {
    id: string;
    fromCertificates?: number;
    toCertificates: number;
    multiplierPercent?: number;

    constructor(obj: BillingMultiplierCreateEditDto) {
        this.id = obj.id;
        this.fromCertificates = obj.fromCertificates;
        this.toCertificates = obj.toCertificates;
        this.multiplierPercent = obj.multiplierPercent;
    }
}

export class BillingSettingEditDto {
    price?: number;
    multipliers: BillingMultiplierCreateEditDto[];

    constructor(obj: BillingSettingEditDto) {
        this.price = obj.price;
        this.multipliers = obj.multipliers;
    }
}

export class BusinessSectorListItemDto {
    id?: string;
    name: string;

    constructor(obj: BusinessSectorListItemDto) {
        this.id = obj.id;
        this.name = obj.name;
    }
}

export class BusinessSectorCreateEditDto {
    name?: string;

    constructor(obj: BusinessSectorCreateEditDto) {
        this.name = obj.name;
    }
}

export class CompanyListItemDto {
    id?: string;
    name: string;
    registryCode: string;
    generalPhone: string;
    generalEmail: string;
    vatNumber: string;
    businessSectorId?: string;
    status?: 1 | 2;
    watermark?: any;
    companyType?: 1 | 2;

    constructor(obj: CompanyListItemDto) {
        this.id = obj.id;
        this.name = obj.name;
        this.registryCode = obj.registryCode;
        this.generalPhone = obj.generalPhone;
        this.generalEmail = obj.generalEmail;
        this.vatNumber = obj.vatNumber;
        this.businessSectorId = obj.businessSectorId;
        this.status = obj.status;
        this.watermark = obj.watermark;
        this.companyType = obj.companyType;
    }
}

export class BusinessSectorDto {
    id?: string;
    name: string;
    companies: CompanyListItemDto[];
    created?: string;

    constructor(obj: BusinessSectorDto) {
        this.id = obj.id;
        this.name = obj.name;
        this.companies = obj.companies;
        this.created = obj.created;
    }
}

export class CertificateListItemParameterDto {
    parameterId?: string;
    name: string;
    value: string;
    order?: number;

    constructor(obj: CertificateListItemParameterDto) {
        this.parameterId = obj.parameterId;
        this.name = obj.name;
        this.value = obj.value;
        this.order = obj.order;
    }
}

export class CertificateListItemDto {
    id?: string;
    hash: string;
    created?: string;
    documentCount?: number;
    templateName: string;
    parameters: CertificateListItemParameterDto[];

    constructor(obj: CertificateListItemDto) {
        this.id = obj.id;
        this.hash = obj.hash;
        this.created = obj.created;
        this.documentCount = obj.documentCount;
        this.templateName = obj.templateName;
        this.parameters = obj.parameters;
    }
}

export class CertificateListParameterDto {
    parameterId?: string;
    title: string;
    order?: number;
    type?: 1 | 2;

    constructor(obj: CertificateListParameterDto) {
        this.parameterId = obj.parameterId;
        this.title = obj.title;
        this.order = obj.order;
        this.type = obj.type;
    }
}

export class CertificateListDto {
    total?: number;
    items: CertificateListItemDto[];
    columns: CertificateListParameterDto[];

    constructor(obj: CertificateListDto) {
        this.total = obj.total;
        this.items = obj.items;
        this.columns = obj.columns;
    }
}

export class CertificateFileDto {
    id?: string;
    name: string;
    size?: number;

    constructor(obj: CertificateFileDto) {
        this.id = obj.id;
        this.name = obj.name;
        this.size = obj.size;
    }
}

export class CertificateParameterValueDto {
    templateParameterId?: string;
    name: string;
    value: string;
    order?: number;
    type?: 1 | 2;

    constructor(obj: CertificateParameterValueDto) {
        this.templateParameterId = obj.templateParameterId;
        this.name = obj.name;
        this.value = obj.value;
        this.order = obj.order;
        this.type = obj.type;
    }
}

export class CertificateIdTitleHashDto {
    id?: string;
    title: string;
    hash: string;

    constructor(obj: CertificateIdTitleHashDto) {
        this.id = obj.id;
        this.title = obj.title;
        this.hash = obj.hash;
    }
}

export class CertificateQldbHashDto {
    certificateId?: string;
    certificateHash: string;
    documentsHash: string;
    parentCertHash: string;
    parameterValuesHash: string;

    constructor(obj: CertificateQldbHashDto) {
        this.certificateId = obj.certificateId;
        this.certificateHash = obj.certificateHash;
        this.documentsHash = obj.documentsHash;
        this.parentCertHash = obj.parentCertHash;
        this.parameterValuesHash = obj.parameterValuesHash;
    }
}

export class CertificateQldbHashValidationDto {
    certificateId?: string;
    certificateHash: string;
    documentsHash: string;
    parentCertHash: string;
    parameterValuesHash: string;
    changesCount?: number;

    constructor(obj: CertificateQldbHashValidationDto) {
        this.certificateId = obj.certificateId;
        this.certificateHash = obj.certificateHash;
        this.documentsHash = obj.documentsHash;
        this.parentCertHash = obj.parentCertHash;
        this.parameterValuesHash = obj.parameterValuesHash;
        this.changesCount = obj.changesCount;
    }
}

export class CertificateDto {
    id?: string;
    templateId?: string;
    templateName: string;
    companyDisclaimer: string;
    canSendToSftp?: any;
    created?: string;
    createdBy?: string;
    companyId?: string;
    files: CertificateFileDto[];
    parameterValues: CertificateParameterValueDto[];
    parentCertificates: CertificateIdTitleHashDto[];
    certificateHashes?: CertificateQldbHashDto;
    blockChainHashes?: CertificateQldbHashValidationDto;
    certValid: any;

    constructor(obj: CertificateDto) {
        this.id = obj.id;
        this.templateId = obj.templateId;
        this.templateName = obj.templateName;
        this.companyDisclaimer = obj.companyDisclaimer;
        this.canSendToSftp = obj.canSendToSftp;
        this.created = obj.created;
        this.createdBy = obj.createdBy;
        this.companyId = obj.companyId;
        this.files = obj.files;
        this.parameterValues = obj.parameterValues;
        this.parentCertificates = obj.parentCertificates;
        this.certificateHashes = obj.certificateHashes;
        this.blockChainHashes = obj.blockChainHashes;
        this.certValid = obj.certValid;
    }
}

export class WatermarkDto {
    watermarkImgBase64: string;
    watermarkText: string;

    constructor(obj: WatermarkDto) {
        this.watermarkImgBase64 = obj.watermarkImgBase64;
        this.watermarkText = obj.watermarkText;
    }
}

export class CertificateTreeItemDto {
    certificateId?: string;
    hash: string;
    title: string;
    level?: number;
    tree: string;
    treePath: string[];

    constructor(obj: CertificateTreeItemDto) {
        this.certificateId = obj.certificateId;
        this.hash = obj.hash;
        this.title = obj.title;
        this.level = obj.level;
        this.tree = obj.tree;
        this.treePath = obj.treePath;
    }
}

export class CertificateTreeDto {
    certificateId?: string;
    hash: string;
    title: string;
    parentCertificates: CertificateTreeItemDto[];
    childCertificates: CertificateTreeItemDto[];

    constructor(obj: CertificateTreeDto) {
        this.certificateId = obj.certificateId;
        this.hash = obj.hash;
        this.title = obj.title;
        this.parentCertificates = obj.parentCertificates;
        this.childCertificates = obj.childCertificates;
    }
}

export class CertificateFileLinkDto {
    fileId?: string;
    hash: string;

    constructor(obj: CertificateFileLinkDto) {
        this.fileId = obj.fileId;
        this.hash = obj.hash;
    }
}

export class CertificateCreateDto {
    certificateFiles: CertificateFileLinkDto[];
    certificateParameterValues: CertificateParameterValueDto[];
    parentCertificates: string[];
    companyId?: string;

    constructor(obj: CertificateCreateDto) {
        this.certificateFiles = obj.certificateFiles;
        this.certificateParameterValues = obj.certificateParameterValues;
        this.parentCertificates = obj.parentCertificates;
        this.companyId = obj.companyId;
    }
}

export class EnumIdNameDto {
    id?: number;
    name: string;

    constructor(obj: EnumIdNameDto) {
        this.id = obj.id;
        this.name = obj.name;
    }
}

export class CompanyCreateEditDto {
    name?: string;
    registryCode?: string;
    generalPhone: string;
    generalEmail: string;
    vatNumber: string;
    country: string;
    city: string;
    street: string;
    postalCode: string;
    disclaimer: string;
    downloadType?: 0 | 1 | 2;
    businessSectorId?: string;
    watermark?: any;
    watermarkData?: WatermarkDto;
    companyType?: 1 | 2;

    constructor(obj: CompanyCreateEditDto) {
        this.name = obj.name;
        this.registryCode = obj.registryCode;
        this.generalPhone = obj.generalPhone;
        this.generalEmail = obj.generalEmail;
        this.vatNumber = obj.vatNumber;
        this.country = obj.country;
        this.city = obj.city;
        this.street = obj.street;
        this.postalCode = obj.postalCode;
        this.disclaimer = obj.disclaimer;
        this.downloadType = obj.downloadType;
        this.businessSectorId = obj.businessSectorId;
        this.watermark = obj.watermark;
        this.watermarkData = obj.watermarkData;
        this.companyType = obj.companyType;
    }
}

export class UserRoleDto {
    role: string;
    created?: string;

    constructor(obj: UserRoleDto) {
        this.role = obj.role;
        this.created = obj.created;
    }
}

export class UserCompanyRoles {
    id?: string;
    companyId?: string;
    companyName: string;
    companyType?: 1 | 2;
    status?: 1 | 2 | 3 | 4;
    roles: UserRoleDto[];

    constructor(obj: UserCompanyRoles) {
        this.id = obj.id;
        this.companyId = obj.companyId;
        this.companyName = obj.companyName;
        this.companyType = obj.companyType;
        this.status = obj.status;
        this.roles = obj.roles;
    }
}

export class UserDto {
    id?: string;
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    userCompaniesRoles: UserCompanyRoles[];

    constructor(obj: UserDto) {
        this.id = obj.id;
        this.username = obj.username;
        this.firstName = obj.firstName;
        this.lastName = obj.lastName;
        this.email = obj.email;
        this.phone = obj.phone;
        this.userCompaniesRoles = obj.userCompaniesRoles;
    }
}

export class BusinessSectorMinimalDto {
    id?: string;
    name: string;

    constructor(obj: BusinessSectorMinimalDto) {
        this.id = obj.id;
        this.name = obj.name;
    }
}

export class CompanyDto {
    id?: string;
    name: string;
    registryCode: string;
    generalPhone: string;
    generalEmail: string;
    vatNumber: string;
    country: string;
    city: string;
    street: string;
    postalCode: string;
    disclaimer: string;
    watermark?: any;
    watermarkData?: WatermarkDto;
    downloadType?: 0 | 1 | 2;
    status?: 1 | 2;
    companyUsers: UserDto[];
    businessSector?: BusinessSectorMinimalDto;
    companyType?: 1 | 2;

    constructor(obj: CompanyDto) {
        this.id = obj.id;
        this.name = obj.name;
        this.registryCode = obj.registryCode;
        this.generalPhone = obj.generalPhone;
        this.generalEmail = obj.generalEmail;
        this.vatNumber = obj.vatNumber;
        this.country = obj.country;
        this.city = obj.city;
        this.street = obj.street;
        this.postalCode = obj.postalCode;
        this.disclaimer = obj.disclaimer;
        this.watermark = obj.watermark;
        this.watermarkData = obj.watermarkData;
        this.downloadType = obj.downloadType;
        this.status = obj.status;
        this.companyUsers = obj.companyUsers;
        this.businessSector = obj.businessSector;
        this.companyType = obj.companyType;
    }
}

export class ReportCompanyDto {
    companyId?: string;
    companyName: string;
    reader2Count?: number;
    reader2CountPeriod?: number;
    filesResultsCount?: number;
    filesInCertificatesAutoCount?: number;
    filesInCertificatesManualCount?: number;
    certificatesCount?: number;
    sizeUploadManualMb?: number;
    sizeCertificatesUploadAutoMb?: number;
    sizeResultsUploadAutoMb?: number;
    sizeDownloadManualMb?: number;
    sizeDownloadAutoMb?: number;
    watermarkDownloadCount?: number;

    constructor(obj: ReportCompanyDto) {
        this.companyId = obj.companyId;
        this.companyName = obj.companyName;
        this.reader2Count = obj.reader2Count;
        this.reader2CountPeriod = obj.reader2CountPeriod;
        this.filesResultsCount = obj.filesResultsCount;
        this.filesInCertificatesAutoCount = obj.filesInCertificatesAutoCount;
        this.filesInCertificatesManualCount = obj.filesInCertificatesManualCount;
        this.certificatesCount = obj.certificatesCount;
        this.sizeUploadManualMb = obj.sizeUploadManualMb;
        this.sizeCertificatesUploadAutoMb = obj.sizeCertificatesUploadAutoMb;
        this.sizeResultsUploadAutoMb = obj.sizeResultsUploadAutoMb;
        this.sizeDownloadManualMb = obj.sizeDownloadManualMb;
        this.sizeDownloadAutoMb = obj.sizeDownloadAutoMb;
        this.watermarkDownloadCount = obj.watermarkDownloadCount;
    }
}

export class ReportByCompanyDto {
    companies: ReportCompanyDto[];
    from?: string;
    to?: string;

    constructor(obj: ReportByCompanyDto) {
        this.companies = obj.companies;
        this.from = obj.from;
        this.to = obj.to;
    }
}

export class TemplateListItemDto {
    id?: string;
    name: string;
    businessSectorId?: string;

    constructor(obj: TemplateListItemDto) {
        this.id = obj.id;
        this.name = obj.name;
        this.businessSectorId = obj.businessSectorId;
    }
}

export class TemplateParameterCreateEditDto {
    id: string;
    name: string;
    required?: any;
    visibleInList?: any;
    order?: number;
    type?: 1 | 2;

    constructor(obj: TemplateParameterCreateEditDto) {
        this.id = obj.id;
        this.name = obj.name;
        this.required = obj.required;
        this.visibleInList = obj.visibleInList;
        this.order = obj.order;
        this.type = obj.type;
    }
}

export class TemplateCreateEditDto {
    name: string;
    businessSectorId?: string;
    parameters: TemplateParameterCreateEditDto[];

    constructor(obj: TemplateCreateEditDto) {
        this.name = obj.name;
        this.businessSectorId = obj.businessSectorId;
        this.parameters = obj.parameters;
    }
}

export class TemplateParameterDto {
    id?: string;
    templateId?: string;
    name: string;
    required?: any;
    visibleInList?: any;
    order?: number;
    type?: 1 | 2;
    created?: string;
    modified: string;

    constructor(obj: TemplateParameterDto) {
        this.id = obj.id;
        this.templateId = obj.templateId;
        this.name = obj.name;
        this.required = obj.required;
        this.visibleInList = obj.visibleInList;
        this.order = obj.order;
        this.type = obj.type;
        this.created = obj.created;
        this.modified = obj.modified;
    }
}

export class TemplateDto {
    id?: string;
    name: string;
    created?: string;
    modified: string;
    templateParameters: TemplateParameterDto[];
    businessSector?: BusinessSectorMinimalDto;

    constructor(obj: TemplateDto) {
        this.id = obj.id;
        this.name = obj.name;
        this.created = obj.created;
        this.modified = obj.modified;
        this.templateParameters = obj.templateParameters;
        this.businessSector = obj.businessSector;
    }
}

export class UserListItemDto {
    id?: string;
    firstName: string;
    lastName: string;
    companyId?: string;
    userCompaniesRoles: UserCompanyRoles[];

    constructor(obj: UserListItemDto) {
        this.id = obj.id;
        this.firstName = obj.firstName;
        this.lastName = obj.lastName;
        this.companyId = obj.companyId;
        this.userCompaniesRoles = obj.userCompaniesRoles;
    }
}

export class UserCreateDto {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone: string;
    username?: string;
    password?: string;

    constructor(obj: UserCreateDto) {
        this.firstName = obj.firstName;
        this.lastName = obj.lastName;
        this.email = obj.email;
        this.phone = obj.phone;
        this.username = obj.username;
        this.password = obj.password;
    }
}

export class UserEditDto {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone: string;
    userCompaniesRoles: UserCompanyRoles[];

    constructor(obj: UserEditDto) {
        this.firstName = obj.firstName;
        this.lastName = obj.lastName;
        this.email = obj.email;
        this.phone = obj.phone;
        this.userCompaniesRoles = obj.userCompaniesRoles;
    }
}

export class CompanyUsersEditDto {
    userCompaniesRoles: UserCompanyRoles[];

    constructor(obj: CompanyUsersEditDto) {
        this.userCompaniesRoles = obj.userCompaniesRoles;
    }
}

export class MethodOptions {
    headers?: any = {};
    returnResponse?: boolean = false;

    constructor(options: MethodOptions) {
        if (options.headers) {
            this.headers = options.headers;
        }
        if (options.returnResponse) {
            this.returnResponse = options.returnResponse;
        }
    }
}

export class ApiBillingSettingsGuidGetArgs {
    guid: string;

    constructor(args: ApiBillingSettingsGuidGetArgs) {
        this.guid = args.guid;
    }
}

export class ApiBillingSettingsGuidPutArgs {
    guid: string;

    constructor(args: ApiBillingSettingsGuidPutArgs) {
        this.guid = args.guid;
    }
}

export class ApiBillingSettingsGuidDeleteArgs {
    guid: string;

    constructor(args: ApiBillingSettingsGuidDeleteArgs) {
        this.guid = args.guid;
    }
}

export class ApiBusinessSectorGuidGetArgs {
    guid: string;

    constructor(args: ApiBusinessSectorGuidGetArgs) {
        this.guid = args.guid;
    }
}

export class ApiBusinessSectorGuidPutArgs {
    guid: string;

    constructor(args: ApiBusinessSectorGuidPutArgs) {
        this.guid = args.guid;
    }
}

export class ApiCertificateGetArgs {
    templateId: string;
    skip: number;
    take: number;
    fullSearch?: string;

    constructor(args: ApiCertificateGetArgs) {
        this.templateId = args.templateId;
        this.skip = args.skip;
        this.take = args.take;
        this.fullSearch = args.fullSearch;
    }
}

export class ApiCertificateCertificateIdGetArgs {
    certificateId: string;

    constructor(args: ApiCertificateCertificateIdGetArgs) {
        this.certificateId = args.certificateId;
    }
}

export class ApiCertificateCertificateIdDocumentGetArgs {
    certificateId: string;

    constructor(args: ApiCertificateCertificateIdDocumentGetArgs) {
        this.certificateId = args.certificateId;
    }
}

export class ApiCertificateCertificateIdDocumentDocumentIdGetArgs {
    certificateId: string;
    documentId: string;

    constructor(args: ApiCertificateCertificateIdDocumentDocumentIdGetArgs) {
        this.certificateId = args.certificateId;
        this.documentId = args.documentId;
    }
}

export class ApiCertificateCertificateIdChainGetArgs {
    certificateId: string;

    constructor(args: ApiCertificateCertificateIdChainGetArgs) {
        this.certificateId = args.certificateId;
    }
}

export class ApiCertificateGroupTemplateIdPostArgs {
    templateId: string;

    constructor(args: ApiCertificateGroupTemplateIdPostArgs) {
        this.templateId = args.templateId;
    }
}

export class ApiCertificateFileFileIdDeleteArgs {
    fileId: string;

    constructor(args: ApiCertificateFileFileIdDeleteArgs) {
        this.fileId = args.fileId;
    }
}

export class ApiCertificateSftpCertificateIdRefReferenceValuePostArgs {
    certificateId: string;
    referenceValue?: string;

    constructor(args: ApiCertificateSftpCertificateIdRefReferenceValuePostArgs) {
        this.certificateId = args.certificateId;
        this.referenceValue = args.referenceValue;
    }
}

export class ApiCertificateFixdocumentsizeSayPostArgs {
    say?: string;

    constructor(args: ApiCertificateFixdocumentsizeSayPostArgs) {
        this.say = args.say;
    }
}

export class ApiCompanyGuidGetArgs {
    guid: string;

    constructor(args: ApiCompanyGuidGetArgs) {
        this.guid = args.guid;
    }
}

export class ApiCompanyGuidPutArgs {
    guid: string;

    constructor(args: ApiCompanyGuidPutArgs) {
        this.guid = args.guid;
    }
}

export class ApiCompanyGuidDeleteArgs {
    guid: string;

    constructor(args: ApiCompanyGuidDeleteArgs) {
        this.guid = args.guid;
    }
}

export class ApiCompanyGuidActiveStatusPutArgs {
    guid: string;
    status: any;

    constructor(args: ApiCompanyGuidActiveStatusPutArgs) {
        this.guid = args.guid;
        this.status = args.status;
    }
}

export class ApiReportBycompanyStartEndGetArgs {
    start?: string;
    end?: string;

    constructor(args: ApiReportBycompanyStartEndGetArgs) {
        this.start = args.start;
        this.end = args.end;
    }
}

export class ApiTemplateGetArgs {
    withAllSelection: any;

    constructor(args: ApiTemplateGetArgs) {
        this.withAllSelection = args.withAllSelection;
    }
}

export class ApiTemplateGuidGetArgs {
    guid: string;

    constructor(args: ApiTemplateGuidGetArgs) {
        this.guid = args.guid;
    }
}

export class ApiTemplateGuidPutArgs {
    guid: string;

    constructor(args: ApiTemplateGuidPutArgs) {
        this.guid = args.guid;
    }
}

export class ApiTemplateGuidDeleteArgs {
    guid: string;

    constructor(args: ApiTemplateGuidDeleteArgs) {
        this.guid = args.guid;
    }
}

export class ApiUserIdGetArgs {
    id: string;

    constructor(args: ApiUserIdGetArgs) {
        this.id = args.id;
    }
}

export class ApiUserUserIdPutArgs {
    userId: string;

    constructor(args: ApiUserUserIdPutArgs) {
        this.userId = args.userId;
    }
}

export class ApiUserUserIdCompanyUsersPutArgs {
    userId: string;

    constructor(args: ApiUserUserIdCompanyUsersPutArgs) {
        this.userId = args.userId;
    }
}

export class BillingApi {
    private readonly config: Configuration;

    constructor(config: Configuration | any) {
        this.config = new Configuration(config);
    }

    apiBillingSettingsGet(options: MethodOptions | any = {}): Promise<BillingSettingListItemDto[]> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Billing/settings';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiBillingSettingsPost(body?: BillingSettingCreateDto, options: MethodOptions | any = {}): Promise<BillingSettingDto> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Billing/settings';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiBillingSettingsGuidGet(args: ApiBillingSettingsGuidGetArgs, options: MethodOptions | any = {}): Promise<BillingSettingDto> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Billing/settings/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiBillingSettingsGuidPut(args: ApiBillingSettingsGuidPutArgs, body?: BillingSettingEditDto, options: MethodOptions | any = {}): Promise<BillingSettingDto> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Billing/settings/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'put',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiBillingSettingsGuidDelete(args: ApiBillingSettingsGuidDeleteArgs, options: MethodOptions | any = {}): Promise<any> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Billing/settings/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'delete',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            promise.then(response => {
                if (response.status === 200 || response.status === 204) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            promise.catch(error => reject(error));
        });
    }
}

export class BusinessSectorApi {
    private readonly config: Configuration;

    constructor(config: Configuration | any) {
        this.config = new Configuration(config);
    }

    apiBusinessSectorGet(options: MethodOptions | any = {}): Promise<BusinessSectorListItemDto[]> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/BusinessSector';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiBusinessSectorPost(body?: BusinessSectorCreateEditDto, options: MethodOptions | any = {}): Promise<BusinessSectorDto> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/BusinessSector';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiBusinessSectorGuidGet(args: ApiBusinessSectorGuidGetArgs, options: MethodOptions | any = {}): Promise<BusinessSectorDto> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/BusinessSector/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiBusinessSectorGuidPut(args: ApiBusinessSectorGuidPutArgs, body?: BusinessSectorCreateEditDto, options: MethodOptions | any = {}): Promise<BusinessSectorDto> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/BusinessSector/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'put',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }
}

export class CertificateApi {
    private readonly config: Configuration;

    constructor(config: Configuration | any) {
        this.config = new Configuration(config);
    }

    apiCertificateGet(args: ApiCertificateGetArgs, options: MethodOptions | any = {}): Promise<CertificateListDto> {
        const { templateId, skip, take, fullSearch } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate';
        const params = new URLSearchParams();
        if (templateId !== undefined) {
            params.append('templateId', templateId as any);
        }
        if (skip !== undefined) {
            params.append('skip', skip as any);
        }
        if (take !== undefined) {
            params.append('take', take as any);
        }
        if (fullSearch !== undefined) {
            params.append('fullSearch', fullSearch as any);
        }
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCertificateCertificateIdGet(args: ApiCertificateCertificateIdGetArgs, options: MethodOptions | any = {}): Promise<CertificateDto> {
        const { certificateId } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/{certificateId}';
        url = url.split(['{', '}'].join('certificateId')).join(encodeURIComponent(String(certificateId)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCertificateCertificateIdDocumentGet(args: ApiCertificateCertificateIdDocumentGetArgs, options: MethodOptions | any = {}): Promise<any> {
        const { certificateId } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/{certificateId}/document';
        url = url.split(['{', '}'].join('certificateId')).join(encodeURIComponent(String(certificateId)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            promise.then(response => {
                if (response.status === 200 || response.status === 204) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            promise.catch(error => reject(error));
        });
    }

    apiCertificateCertificateIdDocumentDocumentIdGet(args: ApiCertificateCertificateIdDocumentDocumentIdGetArgs, options: MethodOptions | any = {}): Promise<any> {
        const { certificateId, documentId } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/{certificateId}/document/{documentId}';
        url = url.split(['{', '}'].join('certificateId')).join(encodeURIComponent(String(certificateId)));
        url = url.split(['{', '}'].join('documentId')).join(encodeURIComponent(String(documentId)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            promise.then(response => {
                if (response.status === 200 || response.status === 204) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            promise.catch(error => reject(error));
        });
    }

    apiCertificateWatermarkPreviewPost(body?: WatermarkDto, options: MethodOptions | any = {}): Promise<any> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/watermark/preview';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            promise.then(response => {
                if (response.status === 200 || response.status === 204) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            promise.catch(error => reject(error));
        });
    }

    apiCertificateCertificateIdChainGet(args: ApiCertificateCertificateIdChainGetArgs, options: MethodOptions | any = {}): Promise<CertificateTreeDto> {
        const { certificateId } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/{certificateId}/chain';
        url = url.split(['{', '}'].join('certificateId')).join(encodeURIComponent(String(certificateId)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCertificateGroupTemplateIdPost(args: ApiCertificateGroupTemplateIdPostArgs, body?: CertificateCreateDto, options: MethodOptions | any = {}): Promise<CertificateDto> {
        const { templateId } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/group/{templateId}';
        url = url.split(['{', '}'].join('templateId')).join(encodeURIComponent(String(templateId)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCertificateFileUploadPost(body?: any, options: MethodOptions | any = {}): Promise<CertificateFileLinkDto> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/file/upload';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: { ...headers, ...getHeaders(), ...options.headers },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCertificateFileFileIdDelete(args: ApiCertificateFileFileIdDeleteArgs, options: MethodOptions | any = {}): Promise<any> {
        const { fileId } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/file/{fileId}';
        url = url.split(['{', '}'].join('fileId')).join(encodeURIComponent(String(fileId)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'delete',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            promise.then(response => {
                if (response.status === 200 || response.status === 204) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            promise.catch(error => reject(error));
        });
    }

    apiCertificateSftpCertificateIdRefReferenceValuePost(args: ApiCertificateSftpCertificateIdRefReferenceValuePostArgs, options: MethodOptions | any = {}): Promise<any> {
        const { certificateId, referenceValue } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/sftp/{certificateId}/ref/{referenceValue}';
        url = url.split(['{', '}'].join('certificateId')).join(encodeURIComponent(String(certificateId)));
        url = url.split(['{', '}'].join('referenceValue')).join(encodeURIComponent(String(referenceValue)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            promise.then(response => {
                if (response.status === 200 || response.status === 204) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            promise.catch(error => reject(error));
        });
    }

    apiCertificateFixdocumentsizeSayPost(args: ApiCertificateFixdocumentsizeSayPostArgs, options: MethodOptions | any = {}): Promise<any> {
        const { say } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Certificate/fixdocumentsize/{say}';
        url = url.split(['{', '}'].join('say')).join(encodeURIComponent(String(say)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            promise.then(response => {
                if (response.status === 200 || response.status === 204) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            promise.catch(error => reject(error));
        });
    }
}

export class ClassifierApi {
    private readonly config: Configuration;

    constructor(config: Configuration | any) {
        this.config = new Configuration(config);
    }

    apiClassifierCountriesGet(options: MethodOptions | any = {}): Promise<CountryDto[]> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Classifier/countries';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }
}

export class CompanyApi {
    private readonly config: Configuration;

    constructor(config: Configuration | any) {
        this.config = new Configuration(config);
    }

    apiCompanyStatusesGet(options: MethodOptions | any = {}): Promise<EnumIdNameDto[]> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Company/statuses';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCompanyGet(options: MethodOptions | any = {}): Promise<CompanyListItemDto[]> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Company';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCompanyPost(body?: CompanyCreateEditDto, options: MethodOptions | any = {}): Promise<CompanyDto> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Company';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCompanyGuidGet(args: ApiCompanyGuidGetArgs, options: MethodOptions | any = {}): Promise<CompanyDto> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Company/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCompanyGuidPut(args: ApiCompanyGuidPutArgs, body?: CompanyCreateEditDto, options: MethodOptions | any = {}): Promise<CompanyDto> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Company/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'put',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCompanyGuidDelete(args: ApiCompanyGuidDeleteArgs, options: MethodOptions | any = {}): Promise<any> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Company/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'delete',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            promise.then(response => {
                if (response.status === 200 || response.status === 204) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            promise.catch(error => reject(error));
        });
    }

    apiCompanyMeGet(options: MethodOptions | any = {}): Promise<CompanyDto> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Company/me';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiCompanyGuidActiveStatusPut(args: ApiCompanyGuidActiveStatusPutArgs, options: MethodOptions | any = {}): Promise<CompanyDto> {
        const { guid, status } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Company/{guid}/active/{status}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        url = url.split(['{', '}'].join('status')).join(encodeURIComponent(String(status)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'put',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }
}

export class ReportApi {
    private readonly config: Configuration;

    constructor(config: Configuration | any) {
        this.config = new Configuration(config);
    }

    apiReportBycompanyStartEndGet(args: ApiReportBycompanyStartEndGetArgs, options: MethodOptions | any = {}): Promise<ReportByCompanyDto> {
        const { start, end } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Report/bycompany/{start}/{end}';
        url = url.split(['{', '}'].join('start')).join(encodeURIComponent(String(start)));
        url = url.split(['{', '}'].join('end')).join(encodeURIComponent(String(end)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }
}

export class TemplateApi {
    private readonly config: Configuration;

    constructor(config: Configuration | any) {
        this.config = new Configuration(config);
    }

    apiTemplateGet(args: ApiTemplateGetArgs, options: MethodOptions | any = {}): Promise<TemplateListItemDto[]> {
        const { withAllSelection } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Template';
        const params = new URLSearchParams();
        if (withAllSelection !== undefined) {
            params.append('withAllSelection', withAllSelection as any);
        }
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiTemplatePost(body?: TemplateCreateEditDto, options: MethodOptions | any = {}): Promise<TemplateDto> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Template';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiTemplateGuidGet(args: ApiTemplateGuidGetArgs, options: MethodOptions | any = {}): Promise<TemplateDto> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Template/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiTemplateGuidPut(args: ApiTemplateGuidPutArgs, body?: TemplateCreateEditDto, options: MethodOptions | any = {}): Promise<TemplateDto> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Template/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'put',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiTemplateGuidDelete(args: ApiTemplateGuidDeleteArgs, options: MethodOptions | any = {}): Promise<any> {
        const { guid } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Template/{guid}';
        url = url.split(['{', '}'].join('guid')).join(encodeURIComponent(String(guid)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'delete',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            promise.then(response => {
                if (response.status === 200 || response.status === 204) {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
            promise.catch(error => reject(error));
        });
    }

    apiTemplateTypesGet(options: MethodOptions | any = {}): Promise<EnumIdNameDto[]> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/Template/types';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }
}

export class UserApi {
    private readonly config: Configuration;

    constructor(config: Configuration | any) {
        this.config = new Configuration(config);
    }

    apiUserStatusesGet(options: MethodOptions | any = {}): Promise<EnumIdNameDto[]> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/User/statuses';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiUserCreateRolesGet(options: MethodOptions | any = {}): Promise<string[]> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/User/create/roles';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiUserGet(options: MethodOptions | any = {}): Promise<UserListItemDto[]> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/User';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiUserPost(body?: UserCreateDto, options: MethodOptions | any = {}): Promise<UserDto> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/User';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'post',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiUserIdGet(args: ApiUserIdGetArgs, options: MethodOptions | any = {}): Promise<UserDto> {
        const { id } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/User/{id}';
        url = url.split(['{', '}'].join('id')).join(encodeURIComponent(String(id)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiUserMeGet(options: MethodOptions | any = {}): Promise<UserDto> {
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/User/me';
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'get',
                headers: { ...headers, ...getHeaders(), ...options.headers }
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiUserUserIdPut(args: ApiUserUserIdPutArgs, body?: UserEditDto, options: MethodOptions | any = {}): Promise<UserDto> {
        const { userId } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/User/{userId}';
        url = url.split(['{', '}'].join('userId')).join(encodeURIComponent(String(userId)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'put',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }

    apiUserUserIdCompanyUsersPut(args: ApiUserUserIdCompanyUsersPutArgs, body?: CompanyUsersEditDto, options: MethodOptions | any = {}): Promise<UserDto> {
        const { userId } = args;
        const { fetchMethod, basePath, headers, getHeaders } = this.config;
        let url = '/api/User/{userId}/companyUsers';
        url = url.split(['{', '}'].join('userId')).join(encodeURIComponent(String(userId)));
        const params = new URLSearchParams();
        const query = params.toString();
        return new Promise((resolve, reject) => {
            const promise = fetchMethod(basePath + url + (query ? '?' + query : ''), {
                method: 'put',
                headers: {
                    ...headers, ...getHeaders(),
                    'Content-Type': 'application/json-patch+json',
                    ...options.headers
                },
                body: 'object' === typeof body ? JSON.stringify(body) : body
            });
            if (options.returnResponse) {
                promise.then(response => resolve(response as any));
            } else {
                promise.then(response => {
                    if (response.status === 200 || response.status === 204) {
                        return response.json();
                    } else {
                        reject(response);
                    }
                }).then(data => resolve(data));
            }
            promise.catch(error => reject(error));
        });
    }
}
